import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

const options = {
  name: 'data-table-footer',
};

const useStyles = makeStyles(
  (theme: Theme) => ({
    root: {
      border: 0,
      padding: theme.spacing(1, 2.5),
      ...theme.typography.body3,
    },
    selectRoot: {
      // width: 54,
      textAlign: 'center',
      backgroundColor: theme.palette.grey[50],
      borderRadius: 4,
      margin: theme.spacing(0, 1),
      '&:before, &:after': {
        content: 'none',
      },
    },
    select: {
      padding: 0,
      paddingRight: '24px !important',
      backgroundColor: 'transparent !important',
    },
    selectIcon: {
      top: 'calc(50% - 12px)',
      right: 4,
      color: theme.palette.primary.main,
    },
    input: {
      padding: 0,
      textAlign: 'center',
    },
  }),
  options
);

export default useStyles;
